export default __webpack_public_path__ + "static/3-2d8ef7a126cb0260ec5d1388e43fc969.jpg";